import { render, staticRenderFns } from "./UIRadioSelectors.vue?vue&type=template&id=c6845cf8&scoped=true"
import script from "./UIRadioSelectors.vue?vue&type=script&setup=true&lang=ts"
export * from "./UIRadioSelectors.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UIRadioSelectors.vue?vue&type=style&index=0&id=c6845cf8&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6845cf8",
  null
  
)

export default component.exports